function TextFileViewer({ text = null }) {
    return <div style={{ whiteSpace: 'pre-wrap', margin: '10px' }}>{text}</div>;
}

export default TextFileViewer;
